export default __webpack_public_path__ + "static/media/img_8.692deca6.JPG";